import { formatResultWeight } from '~/utils/weight';
import { Table } from '~/components/Table/Table';
import { Link } from '~/components/Link/Link';
import { Fragment } from 'react/jsx-runtime';
import { formatDate } from '~/utils/date';
import { Result } from '~/apis/ssf';

interface Props {
  result?: Result;
  isLoading: boolean;
}

export function ResultRecordInfoTable({ result, isLoading }: Props) {
  return (
    <Fragment>
      <Table>
        <Table.Head>
          <Table.Row>
            <Table.Col as="th">Namn</Table.Col>
            <Table.Col as="th">Förening</Table.Col>
            <Table.Col as="th">Tävling</Table.Col>
            <Table.Col as="th">Resultat</Table.Col>
            <Table.Col as="th">Datum</Table.Col>
            <Table.Col />
          </Table.Row>
        </Table.Head>
        <Table.Body>
          {isLoading ? (
            <Table.Loading cols={6} />
          ) : (
            result && (
              <Table.Row>
                <Table.Col>
                  <Link to={`/lifters/${result.person.id}`}>
                    {result.person.first_name} {result.person.last_name}
                  </Link>
                </Table.Col>
                <Table.Col>
                  <Link to={`/clubs/${result.club.id}`}>{result.club.name}</Link>
                </Table.Col>
                <Table.Col>{result.group.competition.name}</Table.Col>
                <Table.Col>{formatResultWeight(result.total)}</Table.Col>
                <Table.Col>
                  {result.group.start ? formatDate(new Date(result.group.start), 'yyyy-mm-dd') : '-'}
                </Table.Col>
              </Table.Row>
            )
          )}
        </Table.Body>
      </Table>
    </Fragment>
  );
}
